import {
  getAllModulesInitActions,
  getSectionLayoutInitAction,
  getModuleData,
  getPageInfoInitActions,
} from './common';
import { ModuleType } from '../../../types/modules';
import {
  setSelectedTierEntityId,
  setSelectedTierContentType,
  setSubscriptionsStats,
  setSubscriptionsChartData,
} from '../../actions/subscriptionsSection';
import { setTotalPages } from '../../actions/pageInfo';
import { getCompositeId } from '@wix/da-shared-react/pkg/redux/normalizr/schemas/deviation';
import { DeviationResourceType } from '@wix/da-shared-react/pkg/types/deviation';
import { PapiModuleTierContent } from '@wix/da-papi-types';

export function getSubscriptionsSectionInitActions(
  responseData,
  requestParams
) {
  const requestTierDeviationId =
    parseInt(requestParams.tier_deviationid) || undefined;

  let selectedTierDeviationId = requestTierDeviationId;

  if (!selectedTierDeviationId) {
    const tiersModuleData = getModuleData(
      responseData.sectionData.modules,
      ModuleType.TIERS
    );
    selectedTierDeviationId = tiersModuleData?.tiers[0]?.deviationId;
  }

  const tierContentModuleData: PapiModuleTierContent =
    getModuleData(responseData.sectionData.modules, ModuleType.TIER_CONTENT) ||
    {};
  const { totalPageCount = 1, section } = tierContentModuleData;

  const { overviewSubscriptions, overviewSubscriptionsMonthly } =
    getModuleData(
      responseData.sectionData.modules,
      ModuleType.SUBSCRIPTION_CENTER
    ) || {};

  return [
    ...(selectedTierDeviationId
      ? [
          setSelectedTierEntityId(
            getCompositeId(DeviationResourceType.TIER, selectedTierDeviationId)
          ),
        ]
      : []),
    setSelectedTierContentType(requestParams.section || section),
    setTotalPages(totalPageCount),
    setSubscriptionsStats(overviewSubscriptions?.timePeriods?.P365D),
    setSubscriptionsChartData(overviewSubscriptionsMonthly?.timePeriods?.P28D),
    getSectionLayoutInitAction(responseData, 'subscriptions'),
    ...getAllModulesInitActions(responseData, requestParams),
    ...getPageInfoInitActions(responseData, requestParams),
  ].filter(action => action);
}
